import * as z from "zod/v4";

const ChildDataSchema_ = z.object({ price: z.string(), variantId: z.string() });

export const ChildDataSchema: z.ZodType<ChildData> = ChildDataSchema_;
export interface ChildData extends z.infer<typeof ChildDataSchema_> {}

const BundleDataSchema_ = z.object({ childData: z.array(ChildDataSchema_) });

export const BundleDataSchema: z.ZodType<BundleData> = BundleDataSchema_;
export interface BundleData extends z.infer<typeof BundleDataSchema_> {}
